import React from "react";
export function Hello(){
    return(

        <>
        <marquee>
        <h1>Hello World</h1>
        <h1></h1>
        </marquee>
        </>
    );
} 
